import {
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalHeader,
    MDBModalTitle,
} from "mdb-react-ui-kit";
import styles from "@/styles/common/RequestAQuoteModal.module.scss";
import { useIsMD } from "@/hooks/useWindowSizes";
import React, { FC, useEffect, useState } from "react";
import { ActivityReableTO } from "@/models/common/common";
import userInterfaceSvg from "@/utils/svg-icon/userInterface";
import { RequestAQuoteForm } from "../detail/DetailBooking/RequestAQuoteForm";

/* eslint sonarjs/no-duplicate-string: "off" */
const RequestAQuoteFormModal: FC<{
    show: boolean;
    id: string;
    title: string;
    activities: ActivityReableTO[];
    setShow: () => void;
    // eslint-disable-next-line sonarjs/cognitive-complexity
}> = ({ show, setShow, id, title, activities = [] }) => {
    const [isBrowser, setIsBrowser] = useState(false);

    const isMD = useIsMD();

    const { CloseLine } = userInterfaceSvg;

    useEffect(() => {
        setIsBrowser(typeof window !== "undefined");
    }, []);

    return isBrowser ? (
        <MDBModal show={show} tabIndex="-1" staticBackdrop>
            <MDBModalDialog centered size="lg">
                <MDBModalContent
                    style={{
                        borderRadius: isMD ? "0px" : "24px",
                        backgroundColor: "#f5f5f5",
                    }}
                >
                    <MDBModalHeader className="position-relative border border-0 d-flex justify-content-between px-md-5 py-5 mx-4">
                        <MDBModalTitle
                            className={`${styles.modalTitle} fw-bold`}
                            style={{ color: "#ed6f6f" }}
                        >
                            {title}
                        </MDBModalTitle>
                        <MDBBtn
                            className={`${styles.buttonClose} d-flex justify-content-center shadow-0`}
                            tag="a"
                            color="none"
                            floating
                            style={{
                                color: "rgb(129, 126, 145)",
                                overflow: "visible",
                            }}
                            onClick={setShow}
                        >
                            <CloseLine className="align-self-center" />
                        </MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody
                        className={`${styles.contentBody}  mx-md-4 d-flex flex-row justify-content-between pb-0`}
                    >
                        <RequestAQuoteForm
                            id={id}
                            title={title}
                            activities={activities}
                            setShow={setShow}
                            isInModal
                        />
                    </MDBModalBody>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    ) : null;
};
export default RequestAQuoteFormModal;
